import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massDestroyValueItems } from "../../api/apiValueItems";
import parseError from "../../utils/parseError";

export function useDeleteAllValueItems() {
    const queryClient = useQueryClient();

    const { mutate: deleteAllItemsMutate, isPending } = useMutation({
        mutationFn: massDestroyValueItems,
        onSuccess: (response) => {
            toast.success(response.message || "Deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["value-items"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete value items");
        },
    });

    return { deleteAllItemsMutate, isPending };
}
